import DispatchConstants from '../constants/DispatchConstants';
import CompanyUser from '../model/CompanyUser';

import api from '../utils/api';

const UserManagementActions = {
  requestApplicationAccess(userManagementCompanyId) {
    return (dispatch) =>
      dispatch(api.users.applicationPermissions.createPermissionRequest(userManagementCompanyId)).then((result) => {
        if (!result.success) {
          return Promise.reject(result.error);
        }
        return result.response;
      });
  },
  getUserManagementProfiles() {
    return (dispatch) => {
      dispatch({ type: DispatchConstants.USER_MANAGEMENT_GET_USERS_LOADING });
      return dispatch(api.users.company.getUserManagementProfiles())
        .then((result) => {
          if (result.success) {
            const users = result.response.userProfiles.map((user) => CompanyUser(user));
            return dispatch({
              type: DispatchConstants.USER_MANAGEMENT_GET_USERS_SUCCESS,
              payload: { users },
            });
          }
          return dispatch({
            type: DispatchConstants.USER_MANAGEMENT_GET_USERS_FAIL,
            payload: { error: result.error },
          });
        })
        .catch((error) => {
          return dispatch({
            type: DispatchConstants.USER_MANAGEMENT_GET_USERS_FAIL,
            payload: { error },
          });
        });
    };
  },
};

export default UserManagementActions;
